module.exports = __webpack_public_path__ + "img/icon-card-social.03a47b84.svg";